import { Typography } from '@breetometer/components';
import { ArrowIcon } from 'BreetAssets';
import { ImageComponent } from 'BreetComponents';

import type { IAvailableAccount } from './DialogSwitchUserAccount.helpers';

const AvailableAccount = ({ imgSrc, accountName, accountRole, onClick }: IAvailableAccount) => (
	<div className='list-item'>
		<div className='list-item-left'>
			<div className='list-item-icon'>
				<ImageComponent
					src={imgSrc}
					alt=''
				/>
			</div>
			<div className='list-item-txt'>
				<Typography as='h6'>{accountName}</Typography>
				<Typography>{accountRole}</Typography>
			</div>
		</div>
		<ArrowIcon
			variant='arrowRight'
			focusable
			onClick={onClick}
		/>
	</div>
);

export default AvailableAccount;
